import React from "react";
import { Switch, Route } from "react-router-dom";
import { connect } from 'react-redux';

import DailyRiddle from "../Home/DailyRiddle";
import DailyTask from "../Home/DailyTask";
import DailyProgress from "../Home/DailyProgress";
import { Progress } from "../../components/SharedComponents";
import DVBottomTabar from "../../utils/DVBottomTabar";

class RootHome extends React.Component {

    render() {
        const { height, location, isLogin, history } = this.props;
        if (!isLogin) {
            history.push("/SignIn");
            return null;
        }

        let tabStatus = false, containHeight = height;
        if (location.pathname === "/dashboard") {
            tabStatus = true;
            containHeight = height - 60;
        }
        return (
            <Switch>
                <div>
                    <div style={{ height: containHeight, overflow: "hidden" }}>
                        <Route exact path="/dashboard" component={DailyProgress} />
                        <Route exact path="/dashboard/progress" component={Progress} />
                        <Route exact path="/dashboard/daily-riddle" component={DailyRiddle} />
                        <Route exact path="/dashboard/daily-task" component={DailyTask} />
                    </div>
                    {
                        tabStatus && <DVBottomTabar active="home" />
                    }
                </div>
            </Switch>
        )
    }
}

const mapStateToProps = ({ setting, auth }) => {
    return { height: setting.height, isLogin: auth.isLogin }
}
export default connect(mapStateToProps)(RootHome);